import { render, staticRenderFns } from "./GeneralMarkObrigatorio.vue?vue&type=template&id=2751b5e4&"
import script from "./GeneralMarkObrigatorio.vue?vue&type=script&lang=js&"
export * from "./GeneralMarkObrigatorio.vue?vue&type=script&lang=js&"
import style0 from "./GeneralMarkObrigatorio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports